module.exports = __webpack_public_path__ + "img/logo-um-fe.68f40241.png";